@if (isMobile) {
  <div class="pt-20">
    <app-sidebar-category-link [restrictUser]="restrictUser" [isSidebar]="false"></app-sidebar-category-link>
  </div>
}

@defer (when isConfigLoaded) {
  @defer (on idle) {
    <!-- @defer (when isLoaded; on timer(0.2s)) { -->
    <app-vpn-message></app-vpn-message>
    <!-- @if (isAuth !== '' && isAuth === '0') { -->
    <app-main-banner-container></app-main-banner-container>
    <!-- } @else {
        <app-authorized-main-banner-container></app-authorized-main-banner-container>
      } -->
    <!-- } -->
    @if (isMobile) {
      <app-active-filters></app-active-filters>
    } @else {
      <app-categories></app-categories>
    }
    <app-more-games [category]="'hot'" [newGames]="newGames" [hotGames]="hotGames" [isSimilar]="false"></app-more-games>
    <app-carousel-banner
      type="main"
      slug="carousel-banner"
      uniqueId="1"
      primaryColor="bg-carouselCurrent"
      secondaryColor="bg-carouselCurrent"
      longWidth="w-14"
      shortWidth="w-3.5"></app-carousel-banner>
    <app-more-games
      [category]="'popular'"
      [newGames]="newGames"
      [hotGames]="hotGames"
      [isSimilar]="false"></app-more-games>
    <app-promotions [isPromotionPage]="false"></app-promotions>
    <app-lucky-players [restrictUser]="restrictUser"></app-lucky-players>
  }
}
